import ImpersonationBanner from "@/components/layout/components/ImpersonationBanner";
import { MobileList } from "@/components/mobile-list";
import { useTranslation } from "react-i18next";
import { useContractorPanelCardsList } from "../hooks";
import { CardListItem } from "./CardListItem";
import { EmptyCardsState } from "./EmptyCardsState";

export const ContractorPanelCardsDirectory = () => {
  const { t } = useTranslation();
  const query = useContractorPanelCardsList();

  return (
    <div className="p-4 pb-20">
      <div className="flex items-center gap-2 mb-6 pb-4 border-b">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold text-gray-900 truncate">
            {t("contractorCards.title.relativeMultiple")}
          </h1>
          <p className="text-gray-600 text-sm truncate">
            {t("contractorCards.contractor.subtitle")}
          </p>
        </div>
        <ImpersonationBanner onlyIcon />
      </div>

      <MobileList
        query={query}
        renderItem={(card) => <CardListItem card={card} />}
        className="space-y-3"
        emptyComponent={<EmptyCardsState />}
      />
    </div>
  );
};
